import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'


class SharedAttribute extends APIObject {
  constructor (options) {
    // Init
    super('DM', options)

    this.tags.selected = typeof (this.tags.selected) === 'boolean' ? this.tags.selected : true
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      'created_at',
      'updated_at',
      'created_by',
      'updated_by'
    ])
    return obj
  }
}

class SharedAttributes extends API {
  /**
  * Get all shared attributes for consumer project
  *
  * @return {Array} Shared attribute array
  */
  list () {
    return this.request({
      method: 'GET',
      url: 'v4/shared/attributes'
    })
      .then(attributes => {
        return attributes.map(attribute => {
          try {
            return new SharedAttribute(attribute)
          } catch (err) {
            console.error(err.stack)
            return null
          }
        }).filter(i => i)
      })
  }

  /**
  * Get a shared attribute for consumer project
  *
  * @param   {String}  id  Shared attribute id
  * @return  {Object}  Shared attribute
  */
  async get (id) {
    const attribute = await this.request({
      method: 'GET',
      url: `v4/shared/attributes/${id}`
    })
    return new SharedAttribute(attribute)
  }
}

export default SharedAttributes
export {
  SharedAttribute,
  SharedAttributes
}
